<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ph6">CONTENTS</h2>
<table class="calibre9" summary="toc">
<tbody class="calibre10"><tr class="calibre11"><td class="calibre12">CHAPTER</td>
<td class="calibre13"> </td>
<td class="calibre12">PAGE</td>
</tr>
<tr class="calibre11"><td class="calibre12">I.</td>
<td class="calibre13"><a href="#/Text/Section0003#Chapter_One"><span class="smcap1">The Infant</span></a></td>
<td class="calibre12"><a href="#/Text/Section0003">3</a></td>
</tr>
<tr class="calibre11"><td class="calibre12">II.</td>
<td class="calibre13"><span href="#/Text/Section0004#Chapter_Two" title="Link target outside of Sample"><span class="smcap1">The Girl</span></span></td>
<td class="calibre12"><span href="#/Text/Section0004" title="Link target outside of Sample">61</span></td>
</tr>
<tr class="calibre11"><td class="calibre12">III.</td>
<td class="calibre13"><span href="#/Text/Section0005#Chapter_Three" title="Link target outside of Sample"><span class="smcap1">The Maiden</span></span></td>
<td class="calibre12"><span href="#/Text/Section0005" title="Link target outside of Sample">117</span></td>
</tr>
<tr class="calibre11"><td class="calibre12">IV.</td>
<td class="calibre13"><span href="#/Text/Section0006#Chapter_Four" title="Link target outside of Sample"><span class="smcap1">The Wife</span></span></td>
<td class="calibre12"><span href="#/Text/Section0006" title="Link target outside of Sample">165</span></td>
</tr>
<tr class="calibre11"><td class="calibre12">V.</td>
<td class="calibre13"><span href="#/Text/Section0007#Chapter_Five" title="Link target outside of Sample"><span class="smcap1">The Mother</span></span></td>
<td class="calibre12"><span href="#/Text/Section0007" title="Link target outside of Sample">213</span></td>
</tr>
<tr class="calibre11"><td class="calibre12">VI.</td>
<td class="calibre13"><span href="#/Text/Section0008#Chapter_Six" title="Link target outside of Sample"><span class="smcap1">The Widow</span></span></td>
<td class="calibre12"><span href="#/Text/Section0008" title="Link target outside of Sample">257</span></td>
</tr>
<tr class="calibre11"><td class="calibre12">VII.</td>
<td class="calibre13"><span href="#/Text/Section0009#Chapter_Seven" title="Link target outside of Sample"><span class="smcap1">The Grandmother</span></span></td>
<td class="calibre12"><span href="#/Text/Section0009" title="Link target outside of Sample">293</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?8e2df706